import { render, staticRenderFns } from "./Integral.vue?vue&type=template&id=6b72b4c8&scoped=true&"
import script from "./Integral.vue?vue&type=script&lang=js&"
export * from "./Integral.vue?vue&type=script&lang=js&"
import style0 from "./Integral.vue?vue&type=style&index=0&id=6b72b4c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72b4c8",
  null
  
)

export default component.exports